module.exports = __webpack_public_path__ + "assets/static/png/plategi-grey.dd5a997910185f5b3e36cbabd2179e10.png";


/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/myPayments/images/plategi-grey.png
 ** module id = 517
 ** module chunks = 1
 **/